<h1 class="color-blue account__title rel guts-p-b-2 guts-m-b-5">
  {{ greeting }}
</h1>
<div class="account__form">
  <form
    #loginFormElement
    [action]="formAction"
    [formGroup]="loginForm"
    (keydown)="enterToSubmit($event)"
    method="POST"
    novalidate
    name="loginForm"
    id="loginForm"
  >
    <!-- For hidden form fields -->
    <input
      id="anti-forgery-token-field"
      name="__RequestVerificationToken"
      type="hidden"
      value="{{ antiForgeryToken }}"
      data-dgat="login-form-209"
    />
    <input
      id="returnUrl"
      name="returnUrl"
      type="hidden"
      value="{{ returnUrl }}"
      data-dgat="login-form-b3d"
    />
    <input
      id="utm_source"
      name="utm_source"
      type="hidden"
      value="{{ utmSource }}"
      data-dgat="login-form-e09"
    />
    <input
      id="utm_medium"
      name="utm_medium"
      type="hidden"
      value="{{ utmMedium }}"
      data-dgat="login-form-241"
    />
    <input
      id="utm_campaign"
      name="utm_campaign"
      type="hidden"
      value="{{ utmCampaign }}"
      data-dgat="login-form-a02"
    />

    <!-- Server Instructions -->
    <div
      class="account__message par"
      [ngClass]="{ 'account__message--error': specialInstructionsError }"
      aria-live="polite"
      [innerHTML]="specialInstructions"
    ></div>

    <!-- Validation Errors -->
    <div
      class="account__message account__message--error par"
      aria-live="polite"
      [innerHTML]="validation.errors"
    ></div>

    <!-- Form Inputs -->
    <fieldset class="account__wrapper">
      <div class="username" *ngIf="showEmail">
        <div class="guts-p-b-quart l_flex l_flex-wrap account__textfield">
          <input
            #usernameField
            id="username"
            name="username"
            formControlName="username"
            type="text"
            required
            placeholder="{{ i18n.AccountController_EmailAddress }}"
            autocomplete="username"
            autocapitalize="none"
            data-dgat="loginForm-0ad"
            class="account__textfield--username"
          />
          <!-- Intentional placement before label for JAWS -->
          <df-icon
            icon="info"
            size="small"
            placement="top"
            container="'body'"
            [ngbTooltip]="i18n.loginForm_EmailStateTooltip"
            [attr.aria-label]="i18n.loginForm_EmailStateTooltip"
            tabindex="0"
            role="text"
            class="account__tooltip-icon color-ebony-a45 guts-m-l-half"
            data-dgat="LogIn-5fc"
          ></df-icon>
          <label for="username" class="par--small font-semibold guts-m-r-quart">
            {{ i18n.loginForm_EmailLabel }}
          </label>
        </div>
      </div>
      <div *ngIf="showMoreFields">
        <div class="guts-p-b-quart account__textfield">
          <input
            #passwordField
            id="current-password"
            name="password"
            type="password"
            formControlName="password"
            autocomplete="current-password"
            placeholder="{{ i18n.loginForm_PasswordPlaceholder }}"
            required="required"
            data-dgat="loginForm-5b7"
          />
          <label for="current-password" class="par--small font-semibold">
            {{ i18n.loginForm_PasswordLabel }}
          </label>
        </div>
        <div class="guts-p-b-1 left-text">
          <button
            *ngIf="!ssoOrg?.ssoOnly"
            (click)="goToForgotPassword()"
            class="link color-blue"
            type="button"
            data-dgat="LogIn-a83"
          >
            {{ i18n.AccountController_Forgot }}
          </button>
        </div>
        <div class="left-text guts-p-b-1-half">
          <div class="l_flexbar">
            <input
              type="checkbox"
              id="rememberme"
              name="rememberme"
              formControlName="remember"
              class="account__checkbox"
              data-dgat="loginForm-b2b"
              [value]="true"
            />
            <label for="rememberme" class="color-ebony par--small no-select">
              {{ i18n.AccountController_RememberMe }}
            </label>
            <input
              type="hidden"
              name="rememberme"
              data-dgat="login-form-78e"
              [value]="false"
            />
          </div>
        </div>
      </div>
      <div class="rel" [ngClass]="{ 'guts-p-v-1': !isSso }">
        <div *ngIf="!isMultiIdp || showMoreFields">
          <button
            (click)="submit($event)"
            type="button"
            #continueButton
            df-button
            dfButtonType="primary"
            id="continueBtn"
            class="submit-button full-width"
            data-dgat="LogIn-1c2"
            [ngClass]="{ inactive: disableButton() }"
            [disabled]="disableButton()"
          >
            <df-spinner-button [isSpinning]="buttonSpin">
              <span>
                {{
                  isSso && !showMoreFields
                    ? i18n.AccountController_ContinueWithSSO
                    : i18n.AccountController_Continue
                }}
              </span>
            </df-spinner-button>
          </button>
        </div>
        <div *ngIf="isMultiIdp && !showMoreFields">
          <div
            class="guts-p-b-1-half"
            *ngFor="let idpChoice of multiIdpData"
            data-dgat="loginForm-46d"
          >
            <button
              (click)="chooseIdpOrg(idpChoice.id)"
              type="button"
              df-button
              dfButtonType="primary"
              class="full-width submit-button"
              data-dgat="LogIn-S3n"
              [ngClass]="{ inactive: loading }"
              [disabled]="loading"
            >
              <span>{{ idpChoice.displayName }}</span>
            </button>
          </div>
        </div>
      </div>
      <div
        dgxRecaptcha
        *ngIf="showCaptcha"
        [siteKey]="captchaKey"
        (recaptchaSuccess)="recaptchaSuccess($event)"
        (recaptchaExpired)="recaptchaExpired()"
        class="guts-m-t-1 guts-m-b-2"
      ></div>
    </fieldset>
    <section class="center-text account__wrapper guts-m-t-1" *ngIf="hasExtras">
      <div *ngIf="showLoginUsingPassword">
        <button
          (keydown.enter)="stopSubmissionAndLoginUsingPassword($event)"
          (click)="loginUsingPassword()"
          df-button
          dfButtonType="secondary"
          class="full-width"
          data-dgat="LogIn-32c"
        >
          <span>
            {{ i18n.AccountController_LoginUsingPassword }}
          </span>
        </button>
      </div>
      <div
        *ngIf="showSignup"
        class="delta"
        [ngClass]="{
          'guts-p-t-1-half': isSso,
          'guts-p-t-6 m-guts-p-t-3': !isSso
        }"
      >
        <strong class="font-semibold guts-m-r-1">
          {{ i18n.loginForm_NoAccountCTA }}
        </strong>
        <a
          [href]="signupUrl"
          class="link guts-p-r-quart"
          data-dgat="loginForm-858"
        >
          <span>{{ i18n.loginForm_SignUpNow }}</span>
          <df-icon
            icon="chevron-right"
            size="medium"
            class="guts-h-r-half"
          ></df-icon>
        </a>
      </div>
    </section>
    <!-- This hidden password field allows the browser to remember/autocomplete username and password without messing up the dynamic flow of the form. DO NOT REMOVE!! -->
    <input
      #hiddenPasswordField
      autocomplete="current-password"
      id="hidden-password"
      name="password"
      type="password"
      tabindex="-1"
      class="account__hide-password"
      data-dgat="loginForm-8af"
    />
  </form>

  <!-- Hidden Account Form -->
  <form
    #hiddenAccountForm
    novalidate
    method="post"
    (ngSubmit)="submit($event)"
    [action]="hiddenFormAction"
    id="hiddenAccountForm"
    name="hiddenAccountForm"
    class="hidden"
  >
    <input
      #hiddenUsernameField
      id="hiddenUsername"
      name="username"
      type="text"
      autocomplete="username"
      autocapitalize="none"
      data-dgat="loginForm-5ec"
    />
    <input
      id="hiddenRequestVerificationToken"
      name="__RequestVerificationToken"
      type="hidden"
      value="{{ antiForgeryToken }}"
      data-dgat="login-form-209"
    />
    <input
      id="hiddenReturnUrl"
      name="returnUrl"
      type="hidden"
      value="{{ returnUrl }}"
      data-dgat="login-form-b3d"
    />
    <input
      id="hiddenUtmSource"
      name="utm_source"
      type="hidden"
      value="{{ utmSource }}"
      data-dgat="login-form-e09"
    />
    <input
      id="hiddenUtmMedium"
      name="utm_medium"
      type="hidden"
      value="{{ utmMedium }}"
      data-dgat="login-form-241"
    />
    <input
      id="hiddenUtmCampaign"
      name="utm_campaign"
      type="hidden"
      value="{{ utmCampaign }}"
      data-dgat="login-form-a02"
    />
  </form>

  <!-- Hidden SSO Form -->
  <form
    #ssoForm
    id="ssoform"
    name="ssoform"
    [action]="ssoFormAction"
    method="post"
    *ngIf="ssoId"
  >
    <input
      name="__RequestVerificationToken"
      type="hidden"
      value="{{ antiForgeryToken }}"
      data-dgat="login-form-209"
    />
    <input
      id="ssoReturnUrl"
      name="returnUrl"
      type="hidden"
      value="{{ returnUrl }}"
      data-dgat="login-form-b3d"
    />
    <input
      id="ssoUtmSource"
      name="utm_source"
      type="hidden"
      value="{{ utmSource }}"
      data-dgat="login-form-e09"
    />
    <input
      id="ssoUtmMedium"
      name="utm_medium"
      type="hidden"
      value="{{ utmMedium }}"
      data-dgat="login-form-241"
    />
    <input
      id="ssoUtmCampaign"
      name="utm_campaign"
      type="hidden"
      value="{{ utmCampaign }}"
      data-dgat="login-form-a02"
    />
    <input
      id="ssoId"
      type="hidden"
      name="id"
      value="{{ ssoId }}"
      data-dgat="loginForm-ba5"
    />
    <input
      id="ssoTenant"
      type="hidden"
      name="tenant"
      value="{{ ssoTenant }}"
      data-dgat="loginForm-212"
    />
    <input
      id="ssoType"
      type="hidden"
      name="ssoType"
      value="{{ ssoType }}"
      data-dgat="loginForm-ssoType"
    />
  </form>
</div>
